"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILEventCard = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var typeography_common_1 = require("../typeography/typeography.common");
var user_config_1 = require("../../configs/user.config");
var il_default_avatar_1 = require("../il-student-card/il-default-avatar");
var icon_1 = require("../icon/icon");
function ILEventCard(_a) {
    var sx = _a.sx, className = _a.className, description = _a.description, title = _a.title, avatar = _a.avatar, leftIcon = _a.leftIcon, adornmentLeftIcon = _a.adornmentLeftIcon, adornmentRightIcon = _a.adornmentRightIcon, rightIcon = _a.rightIcon, children = _a.children, _b = _a.textOverflow, textOverflow = _b === void 0 ? 'ellipsis' : _b, hideLeftBorder = _a.hideLeftBorder, hideRightBorder = _a.hideRightBorder, onClick = _a.onClick, props = __rest(_a, ["sx", "className", "description", "title", "avatar", "leftIcon", "adornmentLeftIcon", "adornmentRightIcon", "rightIcon", "children", "textOverflow", "hideLeftBorder", "hideRightBorder", "onClick"]);
    var theme = (0, material_1.useTheme)();
    var classes = 'il-event-card ' + className;
    var color = props.color || theme.palette.action.disabled;
    var iconSx = __assign({ color: color, '& svg': {
            maxHeight: '0.75rem',
            maxWidth: '0.75rem',
        } }, props.iconSx);
    var adornmentIconSx = __assign({ color: color, '& svg': {
            pt: '0.025rem',
            px: '0.25rem',
            maxHeight: '1.5rem',
            height: '100%',
            width: '1.5rem',
        } }, props.adornmentIconSx);
    var sizeReduce = [avatar, rightIcon, leftIcon, adornmentLeftIcon, adornmentRightIcon].filter(Boolean).length + 1;
    return (react_1.default.createElement(material_1.Tooltip, { title: description, arrow: true },
        react_1.default.createElement(material_1.Box, { className: classes, sx: __assign(__assign(__assign(__assign({ borderColor: color, borderTopStyle: 'solid', borderBottomStyle: 'solid' }, (!hideLeftBorder && {
                borderLeftStyle: 'solid',
                borderTopLeftRadius: '0.25rem',
                borderBottomLeftRadius: '0.25rem',
            })), (!hideRightBorder && {
                borderRightStyle: 'solid',
                borderTopRightRadius: '0.25rem',
                borderBottomRightRadius: '0.25rem',
            })), { borderWidth: '0.12rem', backgroundColor: (0, material_1.alpha)(color, 0.12), display: 'flex', flexDirection: 'row', position: 'relative', alignItems: 'center', height: '1.125rem', cursor: 'pointer' }), sx), onClick: onClick },
            adornmentLeftIcon && (react_1.default.createElement(material_1.Box, { sx: {
                    height: '100%',
                    borderTopLeftRadius: '0.25rem',
                    borderBottomLeftRadius: '0.25rem',
                    backgroundColor: (0, material_1.alpha)(color, 0.25),
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    display: 'flex',
                    flexDirection: 'row',
                    alignContent: 'center',
                } },
                react_1.default.createElement(icon_1.Icon, { icon: adornmentLeftIcon, sx: adornmentIconSx, dataTestId: "left-adornment-icon" }))),
            avatar && (react_1.default.createElement(material_1.Box, { sx: { width: '1.25rem' } },
                react_1.default.createElement(material_1.Box, { sx: {
                        position: 'absolute',
                        bottom: '-0.25rem',
                    } },
                    react_1.default.createElement(il_default_avatar_1.ILDefaultAvatar, { style: { maxWidth: '1.25rem', maxHeight: '1.25rem' }, color: (avatar && user_config_1.userConfig.color[avatar]) || avatar })))),
            react_1.default.createElement(material_1.Box, { sx: {
                    my: '0.25rem',
                    mx: '0.5rem',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    maxWidth: "calc(100% - ".concat(sizeReduce, " * 1rem)"),
                    width: '100%',
                } },
                react_1.default.createElement(material_1.Box, { sx: {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: '0.5rem',
                        width: '100%',
                    } },
                    leftIcon && react_1.default.createElement(icon_1.Icon, { icon: leftIcon, sx: iconSx, dataTestId: "left-icon" }),
                    react_1.default.createElement(typeography_common_1.ILBody1, { className: "event-description", sx: {
                            lineHeight: 1,
                            fontSize: '0.75rem',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: textOverflow,
                        } }, title)),
                rightIcon && (react_1.default.createElement(icon_1.Icon, { icon: rightIcon, sx: __assign({ position: 'absolute', right: '0.5rem' }, iconSx), dataTestId: "right-icon" }))),
            adornmentRightIcon && (react_1.default.createElement(material_1.Box, { sx: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignContent: 'center',
                    height: '100%',
                    borderTopRightRadius: '0.25rem',
                    borderBottomRightRadius: '0.25rem',
                    backgroundColor: (0, material_1.alpha)(color, 0.25),
                    borderLeftStyle: 'solid',
                    borderLeftWidth: '1px',
                } },
                react_1.default.createElement(icon_1.Icon, { icon: adornmentRightIcon, sx: adornmentIconSx, dataTestId: "right-adornment-icon" }))),
            children)));
}
exports.ILEventCard = ILEventCard;
